(function () {
  try {
  const {
    filterScooters,
    sortScooters,
    getCta,
    buildStructuredData
  } = window.ScooterComparison;

  function getSafeStorage() {
    try {
      const testKey = "tbh_storage_test";
      window.localStorage.setItem(testKey, "1");
      window.localStorage.removeItem(testKey);
      return window.localStorage;
    } catch {
      const memory = {};
      return {
        getItem(key) {
          return memory[key] || null;
        },
        setItem(key, value) {
          memory[key] = String(value);
        }
      };
    }
  }

  const storage = getSafeStorage();
  const analytics = window.ScooterCommunityAnalytics.createPersistentAnalytics(storage);
  const scooters = window.SCOOTERS;
  const selected = new Set();
  const viewedModelIds = new Set();

  const elements = {
    query: document.querySelector("#query"),
    streetLegalOnly: document.querySelector("#streetLegalOnly"),
    availableOnly: document.querySelector("#availableOnly"),
    minRangeKm: document.querySelector("#minRangeKm"),
    maxPriceEur: document.querySelector("#maxPriceEur"),
    minPayloadKg: document.querySelector("#minPayloadKg"),
    minAfterSalesScore: document.querySelector("#minAfterSalesScore"),
    minPartsAvailabilityScore: document.querySelector("#minPartsAvailabilityScore"),
    rangeValue: document.querySelector("#rangeValue"),
    priceValue: document.querySelector("#priceValue"),
    payloadValue: document.querySelector("#payloadValue"),
    afterSalesValue: document.querySelector("#afterSalesValue"),
    partsValue: document.querySelector("#partsValue"),
    brandFilters: document.querySelector("#brandFilters"),
    suspensionFilters: document.querySelector("#suspensionFilters"),
    tireTypeFilters: document.querySelector("#tireTypeFilters"),
    sortKey: document.querySelector("#sortKey"),
    resultCount: document.querySelector("#resultCount"),
    trendPanel: document.querySelector(".trend-panel"),
    trendList: document.querySelector("#trendList"),
    cardsGrid: document.querySelector("#cardsGrid"),
    compactTable: document.querySelector("#compactTable"),
    tableBody: document.querySelector("#tableBody"),
    compareDock: document.querySelector("#compareDock"),
    compareSummary: document.querySelector("#compareSummary"),
    compareColumns: document.querySelector("#compareColumns"),
    comparisonPanel: document.querySelector("#comparisonPanel"),
    suggestionForm: document.querySelector("#suggestionForm"),
    suggestionStatus: document.querySelector("#suggestionStatus")
  };
  let viewMode = "grid";

  function formatPrice(value) {
    return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(value);
  }

  function unique(values) {
    return [...new Set(values)].sort((a, b) => String(a).localeCompare(String(b), "de"));
  }

  function brandMeta(brand) {
    return scooters.find((scooter) => scooter.brand === brand) || { brand, brandLogo: brand, brandLogoUrl: "" };
  }

  function brandLogoMarkup(brand, className = "brand-logo-img") {
    const meta = brandMeta(brand);
    if (meta.brandLogoUrl) {
      return `<img class="${className}" src="${meta.brandLogoUrl}" alt="${brand} Logo" loading="lazy" referrerpolicy="no-referrer">`;
    }
    return `<b>${meta.brandLogo || brand}</b>`;
  }

  function formatOptionalNumber(value, suffix) {
    return Number.isFinite(Number(value)) && Number(value) > 0 ? `${value} ${suffix}` : "k. A.";
  }

  function formatIndicators(value) {
    if (value === true) return "Ja";
    if (value === false) return "Nein";
    return "k. A.";
  }

  function ratingMarkup(value) {
    const score = Number(value) || 0;
    const stars = Math.max(0, Math.min(5, Math.round(score / 2)));
    const starMarkup = Array.from({ length: 5 }, (_, index) => `<span class="${index < stars ? "is-filled" : ""}">★</span>`).join("");
    return `<span class="rating-stars" aria-label="${score} von 10">${starMarkup}<b>${score}/10</b></span>`;
  }

  function createFacet(container, name, values) {
    container.innerHTML = values.map((value) => `
      <label class="check-chip">
        <input type="checkbox" name="${name}" value="${value}">
        <span>${name === "brand" ? `${brandLogoMarkup(value, "brand-chip-logo")}${brandMeta(value).brandLogoUrl ? `<small>${value}</small>` : ""}` : value}</span>
      </label>
    `).join("");
  }

  function activeValues(name) {
    return [...document.querySelectorAll(`input[name="${name}"]:checked`)].map((input) => input.value);
  }

  function getFilters() {
    return {
      query: elements.query.value,
      streetLegalOnly: elements.streetLegalOnly.checked,
      availableOnly: elements.availableOnly.checked,
      minRangeKm: Number(elements.minRangeKm.value),
      maxPriceEur: Number(elements.maxPriceEur.value),
      minPayloadKg: Number(elements.minPayloadKg.value),
      minAfterSalesScore: Number(elements.minAfterSalesScore.value),
      minPartsAvailabilityScore: Number(elements.minPartsAvailabilityScore.value),
      brands: activeValues("brand"),
      suspension: activeValues("suspension"),
      tireTypes: activeValues("tireType")
    };
  }

  function renderTrends() {
    const trends = analytics.trending(scooters.map((scooter) => scooter.id)).slice(0, 4);
    elements.trendList.innerHTML = trends.map((trend, index) => {
      const scooter = scooters.find((item) => item.id === trend.id);
      return `
        <article class="trend-item">
          <span>${index + 1}</span>
          <strong>${scooter.brand} ${scooter.model}</strong>
          <dl>
            <div><dt>Views</dt><dd>${trend.stats.views}</dd></div>
            <div><dt>Likes</dt><dd>${trend.stats.likes}</dd></div>
            <div><dt>Vergleiche</dt><dd>${trend.stats.compares}</dd></div>
            <div><dt>Klicks</dt><dd>${trend.stats.ctaClicks}</dd></div>
          </dl>
        </article>
      `;
    }).join("");
  }

  function renderCards(items) {
    elements.cardsGrid.classList.toggle("is-list", viewMode === "compact");
    elements.cardsGrid.innerHTML = items.map((scooter) => {
      const cta = getCta(scooter);
      const checked = selected.has(scooter.id) ? "checked" : "";
      const stats = analytics.stats(scooter.id);
      const liked = analytics.store.likedModelIds.has(scooter.id);
      return `
        <article class="product-card">
          <div class="card-media">
            <img src="${scooter.image}" alt="${scooter.brand} ${scooter.model}">
          </div>
          <div class="card-body">
            <div class="card-title-row">
              <div>
                <span class="brand-logo">${brandLogoMarkup(scooter.brand)}${scooter.brandLogoUrl ? `<span>${scooter.brand}</span>` : ""}</span>
                <h3>${scooter.brand} ${scooter.model}</h3>
                <p>${scooter.tagline}</p>
              </div>
            </div>
            <div class="community-row">
              <button type="button" class="like-button" data-like="${scooter.id}" aria-pressed="${liked}">
                <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7.5 21H4.8A2.3 2.3 0 0 1 2.5 18.7v-7.4A2.3 2.3 0 0 1 4.8 9h2.7v12Zm2-11.8 3.7-5.8c.5-.8 1.7-.5 1.8.5l.2 1.8c.1 1-.1 2-.6 2.9l-.2.4h4.1c1.7 0 2.9 1.6 2.4 3.2l-1.6 5.8a4 4 0 0 1-3.9 3H9.5V9.2Z"/></svg>
                ${liked ? "Gefällt mir gesetzt" : "Gefällt mir"} <span>${stats.likes}</span>
              </button>
              <span>${stats.views} Ansichten</span>
            </div>
            <div class="badge-row">${scooter.badges.map((badge) => `<span>${badge}</span>`).join("")}</div>
            <dl class="spec-grid">
              <div><dt>Reichweite</dt><dd>${scooter.rangeKm} km</dd></div>
              <div><dt>Motor</dt><dd>${scooter.nominalPowerW} W</dd></div>
              <div><dt>Peak</dt><dd>${scooter.peakPowerW} W</dd></div>
              <div><dt>Max. Speed</dt><dd>${formatOptionalNumber(scooter.maxSpeedKmh, "km/h")}</dd></div>
              <div><dt>Steigung</dt><dd>${formatOptionalNumber(scooter.climbPercent, "%")}</dd></div>
              <div><dt>Blinker</dt><dd>${formatIndicators(scooter.hasIndicators)}</dd></div>
              <div><dt>Zuladung</dt><dd>${scooter.payloadKg} kg</dd></div>
              <div><dt>Gewicht</dt><dd>${scooter.weightKg} kg</dd></div>
              <div><dt>Reifen</dt><dd>${scooter.tireSizeInch}" ${scooter.tireType}</dd></div>
              <div><dt>Ersatzteile</dt><dd>${ratingMarkup(scooter.partsAvailabilityScore)}</dd></div>
              <div><dt>After-Sales</dt><dd>${ratingMarkup(scooter.afterSalesScore)}</dd></div>
            </dl>
            <div class="card-footer">
              <strong>${formatPrice(scooter.priceEur)}</strong>
              <div>
                <a class="primary-link" href="${cta.primaryUrl}" target="_blank" rel="noopener" data-cta="${scooter.id}">${cta.primaryLabel}</a>
                <button type="button" class="secondary-button" data-compare="${scooter.id}" aria-pressed="${selected.has(scooter.id)}">${checked ? "Auswahl entfernen" : "Vergleichen"}</button>
              </div>
            </div>
          </div>
        </article>
      `;
    }).join("");
  }

  function renderTable(items) {
    elements.tableBody.innerHTML = items.map((scooter) => {
      const cta = getCta(scooter);
      return `
        <tr>
          <td data-label="Vergleich"><input type="checkbox" data-compare="${scooter.id}" ${selected.has(scooter.id) ? "checked" : ""} aria-label="${scooter.model} vergleichen"></td>
          <td data-label="Modell"><strong>${scooter.brand} ${scooter.model}</strong><span>${scooter.streetLegal ? "Mit Straßenzulassung" : "Ohne Straßenzulassung"}</span></td>
          <td data-label="Reichweite">${scooter.rangeKm} km</td>
          <td data-label="Motor">${scooter.nominalPowerW} W</td>
          <td data-label="Peak">${scooter.peakPowerW} W</td>
          <td data-label="Max. Speed">${formatOptionalNumber(scooter.maxSpeedKmh, "km/h")}</td>
          <td data-label="Steigung">${formatOptionalNumber(scooter.climbPercent, "%")}</td>
          <td data-label="Blinker">${formatIndicators(scooter.hasIndicators)}</td>
          <td data-label="Reifen">${scooter.tireSizeInch}" ${scooter.tireType}</td>
          <td data-label="Zuladung">${scooter.payloadKg} kg</td>
          <td data-label="Gewicht">${scooter.weightKg} kg</td>
          <td data-label="Ersatzteile">${ratingMarkup(scooter.partsAvailabilityScore)}</td>
          <td data-label="After-Sales">${ratingMarkup(scooter.afterSalesScore)}</td>
          <td data-label="Preis">${formatPrice(scooter.priceEur)}</td>
          <td data-label="Status"><a href="${cta.primaryUrl}" target="_blank" rel="noopener" data-cta="${scooter.id}">${cta.primaryLabel}</a></td>
        </tr>
      `;
    }).join("");
  }

  function renderComparison() {
    const compared = scooters.filter((scooter) => selected.has(scooter.id));
    elements.compareDock.hidden = compared.length === 0;
    elements.comparisonPanel.hidden = compared.length < 2;
    elements.compareSummary.textContent = `${compared.length} von 4 Scootern ausgewählt`;

    elements.compareColumns.innerHTML = compared.map((scooter) => {
      return `
        <article>
          <img src="${scooter.image}" alt="">
          <h3>${scooter.brand} ${scooter.model}</h3>
          <dl>
            <div><dt>Reichweite</dt><dd>${scooter.rangeKm} km</dd></div>
            <div><dt>Komfort</dt><dd>${scooter.comfortScore}/10</dd></div>
            <div><dt>Service</dt><dd>${scooter.serviceScore}/10</dd></div>
            <div><dt>After-Sales</dt><dd>${ratingMarkup(scooter.afterSalesScore)}</dd></div>
            <div><dt>Ersatzteile</dt><dd>${ratingMarkup(scooter.partsAvailabilityScore)}</dd></div>
            <div><dt>Motor Peak</dt><dd>${scooter.peakPowerW} W</dd></div>
            <div><dt>Max. Speed</dt><dd>${formatOptionalNumber(scooter.maxSpeedKmh, "km/h")}</dd></div>
            <div><dt>Steigung</dt><dd>${formatOptionalNumber(scooter.climbPercent, "%")}</dd></div>
            <div><dt>Blinker</dt><dd>${formatIndicators(scooter.hasIndicators)}</dd></div>
            <div><dt>Reifen</dt><dd>${scooter.tireSizeInch}" ${scooter.tireType}</dd></div>
            <div><dt>Preis</dt><dd>${formatPrice(scooter.priceEur)}</dd></div>
          </dl>
        </article>
      `;
    }).join("");
  }

  function toggleCompare(id) {
    if (selected.has(id)) {
      selected.delete(id);
    } else if (selected.size < 4) {
      selected.add(id);
      analytics.record("compare", id);
    }
    render();
  }

  function recordVisibleModels(items) {
    for (const scooter of items) {
      if (!viewedModelIds.has(scooter.id)) {
        analytics.record("view", scooter.id);
        viewedModelIds.add(scooter.id);
      }
    }
  }

  function render() {
    elements.rangeValue.textContent = Number(elements.minRangeKm.value) > 0 ? `${elements.minRangeKm.value} km` : "Keine Vorgabe";
    elements.priceValue.textContent = Number(elements.maxPriceEur.value) > 0 ? formatPrice(Number(elements.maxPriceEur.value)) : "Keine Vorgabe";
    elements.payloadValue.textContent = Number(elements.minPayloadKg.value) > 0 ? `${elements.minPayloadKg.value} kg` : "Keine Vorgabe";
    elements.afterSalesValue.textContent = Number(elements.minAfterSalesScore.value) > 0 ? `${elements.minAfterSalesScore.value}/10` : "Keine Vorgabe";
    elements.partsValue.textContent = Number(elements.minPartsAvailabilityScore.value) > 0 ? `${elements.minPartsAvailabilityScore.value}/10` : "Keine Vorgabe";

    const filtered = sortScooters(filterScooters(scooters, getFilters()), elements.sortKey.value);
    recordVisibleModels(filtered);
    elements.resultCount.textContent = `${filtered.length} Modelle gefunden`;
    elements.cardsGrid.hidden = viewMode === "list";
    elements.compactTable.hidden = viewMode !== "list";
    elements.trendPanel.hidden = viewMode === "list";
    renderTrends();
    renderCards(filtered);
    renderTable(filtered);
    renderComparison();
  }

  function mountStructuredData() {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(buildStructuredData(sortScooters(scooters).slice(0, 6), "https://trittbretthelden.de/e-scooter-vergleich/"));
    document.head.appendChild(script);
  }

  function openProductLink(event) {
    const ctaLink = event.target.closest("a[data-cta]");
    if (!ctaLink) return false;
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") event.stopImmediatePropagation();
    analytics.record("cta_click", ctaLink.dataset.cta);
    window.open(ctaLink.href, "_blank", "noopener");
    return true;
  }

  createFacet(elements.brandFilters, "brand", unique(scooters.map((scooter) => scooter.brand)));
  createFacet(elements.suspensionFilters, "suspension", unique(scooters.map((scooter) => scooter.suspension)));
  createFacet(elements.tireTypeFilters, "tireType", unique(scooters.map((scooter) => scooter.tireType)));
  mountStructuredData();

  document.addEventListener("input", (event) => {
    if (event.target.matches("[data-compare]")) return;
    if (event.target.matches("input, select")) render();
  });

  document.addEventListener("change", (event) => {
    if (event.target.matches("[data-compare]")) toggleCompare(event.target.dataset.compare);
  });

  document.addEventListener("click", openProductLink, true);

  document.addEventListener("click", (event) => {
    const likeButton = event.target.closest("button[data-like]");
    if (likeButton) {
      analytics.toggleLike(likeButton.dataset.like);
      render();
      return;
    }

    const compareButton = event.target.closest("button[data-compare]");
    if (compareButton) {
      toggleCompare(compareButton.dataset.compare);
      return;
    }
    const viewButton = event.target.closest("button[data-view]");
    if (viewButton) {
      viewMode = viewButton.dataset.view;
      document.querySelectorAll("button[data-view]").forEach((button) => {
        button.setAttribute("aria-pressed", String(button === viewButton));
      });
      render();
    }
    if (event.target.id === "resetFilters") {
      document.querySelectorAll(".filters input[type='checkbox']").forEach((input) => { input.checked = false; });
      elements.query.value = "";
      elements.minRangeKm.value = 0;
      elements.maxPriceEur.value = 0;
      elements.minPayloadKg.value = 0;
      elements.minAfterSalesScore.value = 0;
      elements.minPartsAvailabilityScore.value = 0;
      render();
    }
    if (event.target.id === "openComparison") {
      elements.comparisonPanel.hidden = selected.size < 2;
      elements.comparisonPanel.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (event.target.id === "clearCompare" || event.target.id === "closeComparison") {
      selected.clear();
      render();
    }
  });

  elements.suggestionForm?.addEventListener("submit", (event) => {
    const formData = new FormData(elements.suggestionForm);
    const suggestion = {
      brand: String(formData.get("brand") || "").trim(),
      model: String(formData.get("model") || "").trim(),
      sourceUrl: String(formData.get("sourceUrl") || "").trim(),
      status: "pending_review",
      createdAt: new Date().toISOString()
    };
    const current = JSON.parse(storage.getItem("tbh_scooter_suggestions_v1") || "[]");
    current.push(suggestion);
    storage.setItem("tbh_scooter_suggestions_v1", JSON.stringify(current));
    elements.suggestionStatus.textContent = "Dein E-Mail-Programm wird geöffnet. Bitte die E-Mail dort noch absenden.";
  });

  render();
  } catch (error) {
    const target = document.querySelector(".results") || document.body;
    target.insertAdjacentHTML("afterbegin", `<div class="app-error">Das Vergleichstool konnte nicht geladen werden: ${error.message}</div>`);
    throw error;
  }
})();
